import React, { Component } from "react";
import AdditionalProcess from "../../../components/AdditionalProcess/AdditionalProcess";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AdditionalProcessForm
Description : Componente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
06/10/2023 Sanitago Coca – Se llama al componente de AdditionalProcess con sus respectivos parámetros.
================================================================================ */

class AdditionalProcessForm extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <AdditionalProcess />
        )
    }
}

export default AdditionalProcessForm;